// extracted by mini-css-extract-plugin
export default {"region":"HeaderRegion_region__2Aryb"};